import he from 'he';
import React from 'react';
import {
  Button,
  Col,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import {
  branch,
  compose,
  renderComponent,
  withProps,
  withStateHandlers,
} from 'recompose';
import {
  Icon,
} from '../../../../components';

const AfsLicenceAbsent = () => <div>This user has not yet selected an Afsl licence.</div>

const CurrentAfsl = branch(
  ({ afsLicence }) => !afsLicence,
  renderComponent(AfsLicenceAbsent)
)(({
  afsLicence
}) => (
    [
      <p key='current-afsl' className='current-afsl'>
        {
          afsLicence ?
            `${he.decode(afsLicence.afsLicenceHolder)} - (${afsLicence.afsLicenceNumber})` :
            null
        }
      </p>,
    ]
  )
);

const StaticAfsSetting = ({
  afsLicence,
  tooltip,
  setOverlayRef
}) => (
    <div className='profile--afsl-setting'>
      <div className='inner'>
        <h2>
          <Icon icon='user' /> Australian financial services licence (AFSL)
        </h2>
        <form noValidate>
          <Row>
            <Col xs={12}>
              <fieldset className='text-center'>
                <Row className='text-center'>
                  <Col xs={12}>
                    <OverlayTrigger ref={(ref) => setOverlayRef(ref)} placement='bottom' overlay={tooltip}>
                      <Button bsStyle='plain'>
                        <Icon icon='help' className='hide-on-ie' /> <span>What's this?</span>
                      </Button>
                    </OverlayTrigger>
                  </Col>
                  <Col xs={12}>
                    <CurrentAfsl {...{
                      afsLicence
                    }} />
                  </Col>
                </Row>
              </fieldset>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  );

export default compose(
  withStateHandlers({
    overlayRef: null
  },{
    setOverlayRef: () => (ref) => ({overlay: ref})
  }),
  withProps(({overlayRef}) => ({
    tooltip: (
      <Tooltip id='afsl-tooltip'>
        <Button onClick={() => overlayRef.hide()} className='pull-right full-width close-overlay' bsStyle='plain'>
          <Icon icon='close' />
        </Button>
        <p>
          <strong>
            Australian Financial Services Licence (ASFL)
          </strong>
        </p>
        <p>
          Your AFSL (Australian Financial Services Licence) is a licence given by ASIC
          that allows people or companies to legally carry on a financial services
          business, including selling, advising or dealing in financial products.
        </p>
      </Tooltip>
    )
  }))
)(StaticAfsSetting);



// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/partials/static-afsl-setting.js